import { ButtonProps } from '@ag1/ui';

export const FIRST_STEP_NAME = 'build-bundle-step-0-option';
export const SECOND_STEP_NAME = 'build-bundle-step-1-option';
export const ITEM_INDEX_LIST = `modal-offers-v2-upscribe-step-1`;
export const FREQUENCY_INTERVAL = 30;

export const ButtonStaticProps: ButtonProps = {
  type: 'submit',
  rounded: true,
  fluid: true
};

export enum Step {
  FIRST_STEP = 1,
  SECOND_STEP = 2
}

export enum CheckoutBaBType {
  ONE_TIME = 'oneTime',
  SUBSCRIPTION = 'subscription'
}

export enum ProductTypeOption {
  FIRST_PRODUCT = 'first',
  SECOND_PRODUCT = 'second'
}

export enum SubscriptionType {
  SINGLE = 'single',
  DOUBLE = 'double',
  ONE_TIME = 'one-time',
  FAMILY_PLAN = 'family-plan'
}

export const SANITY_VARIANT_MAP = {
  singleSubscription: SubscriptionType.SINGLE,
  doubleSubscription: SubscriptionType.DOUBLE,
  familySubscription: SubscriptionType.FAMILY_PLAN,
  oneTime: SubscriptionType.ONE_TIME
};
